export default __webpack_public_path__ + "static/media/barrow.f8a75b6e.png";